import React from "react";
import { useTranslation } from "react-i18next";
import { SFRemoveOutlineCircleIcon } from "../../icons";
import SFIconButton from "../../button/iconButton";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

const SFIconButtonStyled = styled(SFIconButton)(() => ({
  padding: 2,
}));

const RemoveButton = (props) => {
  const { t } = useTranslation();
  return (
    <SFIconButtonStyled
      title={t("components.queryBuilder.removeLabel")}
      onClick={props.handleOnClick}
    >
      <SFRemoveOutlineCircleIcon size="xsmall" color="grey400" />
    </SFIconButtonStyled>
  );
};

export default RemoveButton;
